import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.institute.user.document');
import { OnInit, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'wiz-portal-institute-user-document',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.institute.user.document/view.scss */
/* src/app/portal.institute.user.document/view.scss: no such file or directory */`],
})
export class PortalInstituteUserDocumentComponent implements OnInit {
    constructor(@Inject( Service) public service: Service,@Inject( Title)  private title: Title) { }

    @Input() insID: any;
    @Input() mode: any;

    public documents: any = [];

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow(true, "/authenticate");
        this.title.setTitle("기관 문서함 - MY KREONET");
        await this.load();
    }

    public async load() {
        const { code, data } = await wiz.call("load", { insID: this.insID });
        if (code != 200) return await this.service.error("Error!");
        this.documents = data;
        await this.service.render();
    }

    public async download(doc: any) {
        let download = wiz.url('download?id=' + this.insID + "&title=" + doc.title)
        window.open(download, '_blank');
    }

    public getFileIcon(type: string) {
        switch (type.toLowerCase()) {
            case 'pdf': return '📄';
            case 'docx':
            case 'doc': return '📝';
            case 'xlsx':
            case 'xls': return '📊';
            case 'pptx':
            case 'ppt': return '📋';
            case 'txt': return '📃';
            default: return '📁';
        }
    }
}

export default PortalInstituteUserDocumentComponent;